import Footer from '../components/Footer/Footer'
import Navbar from "../components/Navbar/Navbar"
import { galleryPageImages } from '../common/config/constants'
import CardWithModal from '../components/CardWithModal/CardWithModal'

const style={
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}

const Gallery = () => {
    return (
        <>
            <Navbar />
            {/* ensure images inside .card-container keep aspect ratio */}
            <style>{`
                .card-container img {
                    width: 100%;
                    height: auto;
                    object-fit: contain; /* use 'cover' if you prefer fill-with-crop */
                }
            `}</style>

            <div className="container shadow-lg flex-fill">
                <div className="row">
                    {
                        galleryPageImages.map((item, index) => (
                            <div
                                className="col-12 col-md-4 d-flex mt-1 mb-1 card-container"
                                style={style}
                                key={index}
                            >
                                <CardWithModal details={item} />
                            </div>
                        ))
                    }
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Gallery;